export default __webpack_public_path__ + "9821c68c3d78b1908384f9f6b261361f.png";